/**
 * ALERT-NOTICE.JS
 */

import { Cookies } from '../classes/cookies';
import Slideable from '../classes/slideable';

/**
 * Initializes the alert notice in the header navigation menu.
 */
export default function InitAlertNotice() {
	const mainElement = document.querySelector('#alert-notice');
	const slideableMainElement = new Slideable(mainElement);

	if (mainElement === null)
		return;

	initHeaderToggle(mainElement);
	initCloseButton(mainElement, slideableMainElement);

	const cookieIdentifier = getCookieName(mainElement);
	if (Cookies.get(cookieIdentifier) !== 'true') {
		slideableMainElement.toggle();
	}
}

function initCloseButton(alertNoticeElement, slideableAlertNoticeElement) {
	if (alertNoticeElement === null)
		return;

	const closeButton = alertNoticeElement.querySelector('.alert-notice-close-button');

	closeButton.addEventListener('click', () => {
		slideableAlertNoticeElement.down();
		Cookies.set(getCookieName(alertNoticeElement), 'true', 14);
	});
}

function initHeaderToggle(alertNoticeElement, slideableAlertNoticeElement) {
	if (alertNoticeElement === null)
		return;

	const navigationElement = document.querySelectorAll('.button-toggle-alert');

	if (navigationElement.length === 0)
		return;

	navigationElement.addEventListener('click', () => {
		slideableAlertNoticeElement.toggle();
		Cookies.set(getCookieName(alertNoticeElement), 'true', 14);
	});
}

function getCookieName(alertNoticeElement) {
	return alertNoticeElement.getAttribute('data-cookie');
}